[
  {
    "code": "CV-B",
    "name": "Ilhas de Barlavento"
  },
  {
    "code": "CV-S",
    "name": "Ilhas de Sotavento"
  }
]